import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import directive from './directive/index'
import roles from '@/components/Roles'
import theStatus from '@/components/TheStatus'
import theTag from '@/components/TheTag'
import AuthImg from '@/components/AuthImg'
// UI 组件
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './style/index.scss'
import './style/basic.scss'
import { clearExpiredPreMedicalDrafts } from '@/utils/preMedicalDraft'
// 导入 Element Plus 中文语言包
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

clearExpiredPreMedicalDrafts()

const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })
app.use(store).use(router).use(Antd).mount('#app')
app.component('roles', roles)
app.component('the-status', theStatus)
app.component('the-tag', theTag)
app.component('auth-img', AuthImg)
// 加入指令
directive(app)
